const timeTrackingHelpers = {
  prepareLogsData(item) {
    _.mapKeys(item.tasks, (taskLogs, taskId) => {
      if (!_.isArray(taskLogs)) {
        return;
      }

      item.tasks[taskId] = {
        logs: taskLogs,
        sum: _.reduce(taskLogs, (sum, log) => sum + Number(log.time), 0),
      };
    });
  },
};


export default timeTrackingHelpers;
